var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PTabs',{attrs:{"tabs":_vm.tabs,"selected":_vm.tab,"pills":""},on:{"select":_vm.goToTab}}),(_vm.tab === 'invoice')?_c('ListInvoice'):_vm._e(),(_vm.tab === 'credit_note')?_c('ListCreditNote'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }